class UsersActivitiesContainer {
  constructor(
    $location,
    $log,
    $q,
    $sce,
    $timeout,
    $window,
    activitiesParser,
    appErrorHandler,
    appEvents,
    appUtils,
    uimessages,
    users,
    USERS_EVENTS,
  ) {
    'ngInject';

    this.$location = $location;
    this.$log = $log;
    this.$q = $q;
    this.$sce = $sce;
    this.$timeout = $timeout;
    this.$window = $window;
    this.activitiesParser = activitiesParser;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appUtils = appUtils;
    this.uimessages = uimessages;
    this.users = users;
    this.USERS_EVENTS = USERS_EVENTS;

    this.assignmentsSubMenu = {
      id: 'accounts',
      path: '',
      label: 'Accounts Assigned',
    };
    this.subMenu = [
      this.assignmentsSubMenu,
      {
        id: 'activities',
        selected: true,
        label: 'Activities',
      },
    ];

    this.loading = false;
    this.loadingActivities = false;
    this.loadingMoreActivities = false;

    this.infiniteScrollEnabled = true;
    this.user = {};
    this.activities = [];
    this.actionsTypes = {
      download: {
        id: 'download',
        label: 'Download',
      },
    };
    this.headerActions = [];

    this._startDate = null;
    this._endDate = null;
    this._lastId = null;
    this._resetActivities = false;
    this._infiniteScrollActivationDelay = 1000;
  }
  $onChanges({ selectedId }) {
    if (selectedId && selectedId.currentValue) {
      this._loadUser();
    }
  }
  loadActivities() {
    this.infiniteScrollEnabled = false;
    let result;
    if (this.loadingActivities) {
      result = this.$q.reject(new Error('The activities are already being requested'));
    } else {
      const options = {};
      if (this._startDate && this._endDate) {
        options.startDate = this.appUtils.toTimestamp(this._startDate);
        options.endDate = this.appUtils.toTimestamp(this._endDate);
      }

      if (this._lastId && !this._resetActivities) {
        options.lastId = this._lastId;
      }

      this.loading = false;
      this.loadingActivities = true;
      this.loadingMoreActivities = !!(options.lastId && !this._resetActivities);
      result = this.users.getActivities(this.user.id, options)
      .then((activities) => {
        if (this._resetActivities) {
          this.activities = [];
          this._resetActivities = false;
        }
        if (activities.length) {
          this._lastId = activities[activities.length - 1].id;
          this.activities.push(...this.activitiesParser.parse(activities, this.user));
          this._reactivateInfiniteScrollAfterDelay();
        }

        this._resetHeaderActions();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the user activities');
        this.infiniteScrollEnabled = false;
      })
      .then(() => {
        this.loadingActivities = false;
        this.loadingMoreActivities = false;
      });
    }

    return result;
  }
  changeDates(startDate, endDate) {
    this._startDate = startDate;
    this._endDate = endDate;
    this._resetActivities = true;
    this.$timeout(() => {
      this.loadActivities();
    });
  }
  handleHeaderAction(action) {
    switch (action.id) {
    default:
    case this.actionsTypes.download.id:
      this._downloadActivities();
      break;
    }
  }
  openActivity($event, activity) {
    if ($event.target) {
      const detail = this.activitiesParser.getDetailFromElement($event.target);
      if (detail) {
        const html = `
          <div>${activity.summaryHTML}</div>
          <br />
          <div>${detail}</div>
        `;
        this.uimessages.alert(
          'Activity Detail',
          html,
          {
            html: true,
            confirmText: 'Close',
          },
        );
      }
    }
  }
  _loadUser() {
    let result;
    if (this.loading) {
      result = this.$q
      .reject(new Error('The user information is already being requested'));
    } else {
      this.appEvents.emit(this.USERS_EVENTS.load.start, this.selectedId);
      this.loading = true;
      result = this.users.byId(this.selectedId)
      .then((user) => {
        this.user = user;
        this.assignmentsSubMenu.path = `/users/${this.user.id}`;
        this.appEvents.emit(this.USERS_EVENTS.load.success, this.user);
        return this.loadActivities();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the user information');
        this.$location.path(`/users/${this.selectedId}`);
        this.appEvents.emit(this.USERS_EVENTS.load.error, error);
      })
      .then(() => {
        this.loading = false;
        this.appEvents.emit(this.USERS_EVENTS.load.finish);
      });
    }

    return result;
  }
  _resetHeaderActions() {
    this.headerActions = [];
    if (this.activities.length) {
      this.headerActions.push(this.actionsTypes.download);
    }
  }
  _reactivateInfiniteScrollAfterDelay() {
    this.$timeout(() => {
      this.infiniteScrollEnabled = true;
    }, this._infiniteScrollActivationDelay);
  }
  _downloadActivities() {
    const url = this.users.getActivitiesDownloadURL(this.user.id);
    this.$window.location.href = url;
  }
}

export default {
  controller: UsersActivitiesContainer,
  template: `
    <users-activities
      loading="$ctrl.loading"
      loading-activities="$ctrl.loadingActivities && !$ctrl.loadingMoreActivities"
      loading-more-activities="$ctrl.loadingMoreActivities"
      infinite-scroll-enabled="$ctrl.infiniteScrollEnabled"
      user="$ctrl.user"
      activities="$ctrl.activities"
      header-actions="$ctrl.headerActions"
      start-date="$ctrl.startDate"
      end-date="$ctrl.endDate"
      sub-menu="$ctrl.subMenu"
      on-header-action-clicked="$ctrl.handleHeaderAction(action)"
      on-dates-change="$ctrl.changeDates(startDate, endDate)"
      on-infinite-scroll="$ctrl.loadActivities()"
      on-activity-click="$ctrl.openActivity($event, activity)"
    ></users-brands>
  `,
  bindings: {
    selectedId: '<',
  },
};
